import * as React from 'react';
import {IconButton, WithStyles, withStyles,} from '@material-ui/core';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';
import { EditActionStyle } from '../EditAction.style';
import { IScheduleTemplate, } from '@app-types/websocket/schedule.types';
import { styleColors } from 'src/main.style';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof EditActionStyle> {
  offset:number
  shift:number;
  doShift:(direction:"forward"|"back") => void;
  selectedTemplate:IScheduleTemplate;
  selectTmplate:(template:IScheduleTemplate) => void;

}

class WizardShift extends React.Component<IProps> {


  public render() {
    const {classes, shift, doShift, offset} = this.props;

    return (
      <div className={classes.pane+" "+classes.paneStep} style={{ left: (offset*100)+"%", opacity:offset===0?1:0, 
        gap: '16px', paddingTop: '16px'}}>
        <div style={{ display: 'flex',alignItems: 'center', alignSelf: 'center'}}>{tn.lang.calWizardShift}</div>
        <div style={{ display: 'flex',alignItems: 'center', alignSelf: 'center'}}>
          <IconButton onClick={() => doShift("back")} >{'<'}</IconButton>
          <div style={{fontSize: '40px', fontWeight: 600, color: styleColors.greyMedium3}}>{shift}</div>
          <IconButton onClick={() => doShift("forward")} >{'>'}</IconButton>
        </div>
        <div style={{ display: 'flex',alignItems: 'center', alignSelf: 'center'}}>
          <Button variant="contained" classes={{contained:classes.gradientButton}} onClick={() => this.flipDays()}>{tn.lang.invert}</Button>
        </div>
      </div>
    );
  }

  private flipDays() {
    const newTemplate:IScheduleTemplate = {days:[],title:this.props.selectedTemplate.title,type:this.props.selectedTemplate.type,};
    for (const day of this.props.selectedTemplate.days) {
      if (day === "A") {
        newTemplate.days.push("B");
      } else {
        newTemplate.days.push("A");
      }
    }
    this.props.selectTmplate(newTemplate);
  }

}

export default withStyles(EditActionStyle)(WizardShift);



// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/editActions/Wizard/WizardShift.tsx